import { HttpRequest } from '@angular/common/http';

/** Peticiones de auth pública donde un 401 es un fallo esperado (credenciales), no sesión expirada. */
export function isPublicAuthHttpRequest(req: HttpRequest<unknown>): boolean {
  const url = req.url;
  return (
    url.includes('/api/v1/auth/login') ||
    url.includes('/api/v1/auth/google_oauth') ||
    url.includes('/api/v1/auth/forgot_password') ||
    url.includes('/api/v1/auth/reset_password')
  );
}
